/* ============================================================================
   ATC TOAST + FAQ ACCORDION  —  pure JS

   Split out of the inline <script>. Logic unchanged. The only Liquid in the
   original was the {% if page.handle == 'faq' %} gate around the accordion —
   that is now window.__pageConfig.isFaqPage, emitted inline before this loads.

   showATC() is a TOP-LEVEL function declaration (no IIFE wrapper) so it stays on
   `window` exactly as it was when inline — whatever calls it after an add to
   cart keeps resolving it.
   ============================================================================ */

function showATC(message = "Product(s) added to cart") {
  const toast = document.getElementById("atcToast");
  const toastMsg = document.getElementById("atcToastMsg");
  const liveRegion = document.getElementById("atcAriaLive");

  // Show the message visually
  toastMsg.textContent = message;
  toast.style.display = "block";

  // Update the hidden live region for screen readers
  liveRegion.textContent = '';
  setTimeout(() => {
    liveRegion.textContent = message;
  }, 100); // small delay helps screen readers

  // Hide toast after 2 seconds
  setTimeout(() => {
    toast.style.display = "none";
    liveRegion.textContent = ''; // Optional cleanup
  }, 2000);
}

/* FAQ page only — was {% if page.handle == 'faq' %} … {% endif %} */
if ((window.__pageConfig || {}).isFaqPage) {
  const faqHeaders = document.querySelectorAll('.faq-que-div-header');

  faqHeaders.forEach(header => {
    header.addEventListener('click', function () {
      const content = this.nextElementSibling;
      this.classList.toggle('active');

      content.style.display = (content.style.display === 'block') ? 'none' : 'block';
    });
  });
}
